import {
  ArrowOption,
  DEFAULT_ANCHOR_BY_TYPE,
  DimensionSide,
  ElementState,
  ElementType,
  LineType,
  Point,
  Polyline,
  THICKNESS_PRESETS,
} from '@ritabygglov/core';

const getThickness = (lineType: LineType) => {
  if (lineType === LineType.Line) return THICKNESS_PRESETS.S;
  return THICKNESS_PRESETS.S;
};

const getShowDimension = (lineType: LineType) => {
  if (lineType === LineType.Dimension) return true;
  return false;
};

const getDimensionFontSize = (lineType: LineType) => {
  if (lineType === LineType.Dimension) return '14px';
  return undefined;
};

export const toggleDimensionSide =
  (pointIndex: number) => (p: Point, i: number) => {
    if (i === pointIndex) {
      const newDimensionSide =
        p.dimensionSide === DimensionSide.Above
          ? DimensionSide.Below
          : DimensionSide.Above;
      return {
        ...p,
        dimensionSide: newDimensionSide,
      };
    } else {
      return p;
    }
  };

export const createPolyline = (
  point: Point,
  renderingOrder: number,
  id: string,
  userId: string,
  lineType = LineType.Line,
  points: Point[] | undefined = undefined,
  options: Partial<Polyline> = {}
): Polyline => {
  return {
    type: ElementType.Polyline,
    text: '',
    rotate: 0,
    style: {
      stroke: '#000',
      strokeDasharray: undefined,
      fontSize: getDimensionFontSize(lineType),
    },
    thickness: getThickness(lineType),
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Polyline],
    state: ElementState.Creation,
    renderingOrder,
    userVersion: {
      userId,
      version: 1,
    },
    stroke: '',
    leftArrow: ArrowOption.none,
    rightArrow: ArrowOption.none,
    showDimensions: getShowDimension(lineType),
    lineType,
    isOutlined: false,
    diagonalHatch: false,
    ...options,
    points: points ? points : [point],
    id,
  };
};
